import React, { useEffect, useState } from 'react';
import Form from './Form';
import Titel from '../Titel';
import axios from 'axios';

const Capillary = () => {
    const [data, setData] = useState()
    const [reload, setReload] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    useEffect(() => {
        const fetchPainting = async () => {
            await axios.get('/capillary-search')
                .then(res => {
                    setData(res.data.data)
                })
                .catch(err => setError(err.response?.data.message || "مشکل در بارگزاری اطلاعات"))
                .finally(() => setLoading(false))
        };

        fetchPainting();
    }, [reload]);

    if (loading) {
        return <div className="centerOfParent h-screen w-full">درحال‌بارگذاری</div>;
    }

    if (error) {
        return <div className="centerOfParent h-screen w-full">{error}</div>;
    }

    if (!data) {
        return <div className="centerOfParent h-screen w-full">اطلاعات پیدا نشد</div>;
    }

    return (
        <>
            <main>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2">
                        <Titel title='سطح اول' />
                        <div className="flex items-center gap-4">
                            {data['1'].map((e, i) => <Form index={i} setReload={setReload} key={e.id} id={e.id} />)}
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <Titel title='سطح دوم' />
                        <div className="flex items-center gap-4">
                            {data['2'].map((e, i) => <Form index={i} setReload={setReload} key={e.id} id={e.id} />)}
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <Titel title='سطح سوم' />
                        <div className="flex items-center gap-4">
                            {data['3'].map((e, i) => <Form index={i} setReload={setReload} key={e.id} id={e.id} />)}
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <Titel title='سطح چهار' />
                        <div className="flex items-center gap-4">
                            {data['4'].map((e, i) => <Form index={i} setReload={setReload} key={e.id} id={e.id} />)}
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <Titel title='سطح پنجم' />
                        <div className="flex items-center gap-4">
                            {data['5'].map((e, i) => <Form index={i} setReload={setReload} key={e.id} id={e.id} />)}
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Capillary;